import { trackEvent } from './analytics';
import { trackUmamiEvent } from './umami';

export type QuestionRole = 'organizer' | 'participant';

export type QuestionContext =
  | 'invite_personal_links'
  | 'invite_email'
  | 'invite_shared_link'
  | 'participant_access_troubleshooting'
  | 'draw_circle'
  | 'draw_odd_participants'
  | 'draw_after';

/** One event per opening; categorical context only, without participant data. */
export function trackQuestionOpened(context: QuestionContext, role: QuestionRole): void {
  const data = { context, role };
  try { trackEvent('question_opened', data); } catch { /* Help must remain available. */ }
  try { void Promise.resolve(trackUmamiEvent('question_opened', data)).catch(() => {}); }
  catch { /* Tracker unavailable. */ }
}

/** Wrap the opening action so repeated intentional openings are counted. */
export function questionOpener(context: QuestionContext, role: QuestionRole, open: () => unknown): () => void {
  return () => {
    open();
    trackQuestionOpened(context, role);
  };
}
